import { useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

const PROVIDED_BY_GROUP_DATA_TEXT =
  'a new repo will be provided within the common platform ADO project';

export const AdoProjectNameField = ({
  onChange,
  rawErrors,
  required,
  formData,
  formContext,
  schema,
  uiSchema,
}: FieldExtensionComponentProps<string>) => {
  const workspaceSelection = formContext?.formData?.ado_workspace as
    | 'own_project_and_repo'
    | 'provided_by_group_data'
    | undefined;

  const isOwnProject = workspaceSelection === 'own_project_and_repo';
  const isProvidedByGroupData = workspaceSelection === 'provided_by_group_data';

  useEffect(() => {
    if (isProvidedByGroupData && formData !== PROVIDED_BY_GROUP_DATA_TEXT) {
      onChange(PROVIDED_BY_GROUP_DATA_TEXT);
      return;
    }

    if (isOwnProject && formData === PROVIDED_BY_GROUP_DATA_TEXT) {
      onChange(undefined);
    }
  }, [isOwnProject, isProvidedByGroupData, formData, onChange]);

  const hasError = Boolean(rawErrors?.length);

  return (
    <TextField
      fullWidth
      margin="normal"
      label={schema?.title ?? 'ADO Project Name'}
      required={required && isOwnProject}
      error={hasError}
      helperText={
        hasError
          ? rawErrors?.join(', ')
          : (uiSchema?.['ui:help'] as string | undefined) ?? schema?.description
      }
      disabled={!isOwnProject}
      value={formData ?? ''}
      onChange={e => onChange(e.target.value || undefined)}
    />
  );
};
